"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementsObject = void 0;
const elements_js_1 = require("./elements.js");
exports.elementsObject = {};
for (const element of elements_js_1.elements) {
    exports.elementsObject[element.symbol] = element;
}
//# sourceMappingURL=elementsObject.js.map